
/* injects from baggage-loader */

'use strict';

import ProjectDonationWizardStep1Component from './project-donation-wizard.step1.component';

const ProjectDonationWizardStep1PageModule = angular.module('project-donation-wizard-step-1-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('project-donation-wizard.step1', {
        url: '/1',
        component: 'projectDonationWizardStep1',
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          profile: function(Profiles) {
            return Profiles.fetchOwn()
          }
        }
      });
  })
  .component('projectDonationWizardStep1', new ProjectDonationWizardStep1Component());

export default ProjectDonationWizardStep1PageModule;



// WEBPACK FOOTER //
// ./src/app/pages/project-donation-wizard/step1/project-donation-wizard.step1.module.js